/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon16Solid = forwardRef('SendPaperplaneIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M14.496 6.88 3.434 1.366a1 1 0 0 0-1.427 1.088l.786 3.99a1 1 0 0 0 .981.806H8a.75.75 0 1 1 0 1.5H3.774a1 1 0 0 0-.981.806l-.786 3.982a1 1 0 0 0 1.427 1.089l11.061-5.51c.924-.46.924-1.776 0-2.237Z" })));
});
